import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import models from '@/model';

export const fetchJackpotBetFeedsByLiquidity = (
  context: LogicContext
) => async () => {
  const currency = context.user?.currency || config.default_currency;

  const data = await models.fetchJackpotBetFeedsByLiquidity({
    currency,
  });

  if (data) {
    return {
      status: 200,
      data,
    };
  }

  console.error('There was a problem while fetching Jackpot Bet feeds.');
  return {
    status: 400,
    data: {},
  };
};
